import type { AudioManager } from '../audio-manager';
import { getCachedAssetURLIfExists } from '../asset-prefetcher';

let _audioManager: AudioManager | null = null;

export function initPlayAudioImplementation(audioManager: AudioManager) {
  _audioManager = audioManager;
}

export async function runPlayAudioImplementation(data: { audio?: { url?: string } }) {
  if (!_audioManager) return;
  const url = data?.audio?.url;
  if (!url) {
    console.warn('Play audio: missing audio url (is the audio input connected?)');
    return;
  }
  await _audioManager.play(getCachedAssetURLIfExists(url), 'scene');
  if (_audioManager.isPlaying('scene')) {
    await _audioManager.waitUntilPlaybackEnded('scene');
  }
}
